import {
  GET_NOTIFICATIONS_LIST,
  PUT_NOTIFICATIONS_STATUS,
  GET_UNREAD_NOTIFICATIONS,
  SAVE_FIREBASE_TOKEN,
  LOGOUT_FIREBASE_TOKEN
} from "../../data/APIEndpoints";
import axios from "../AxiosInstance";
import { getStorageValue, getEncryptedStorageValue } from "../../utils/helper";

const fetchNotificationsList = async (userId, pageNumber, pageCount) => {
  let url =
    GET_NOTIFICATIONS_LIST +
    `?userId=${userId}&PageNumber=${pageNumber}&pageSize=${pageCount}`;

  try {
    const response = await axios.get(url);
    if (response.status === 200 || response.status === 201) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "An error occurred while processing the data.",
      error: error,
    };
  }
};

const updateNotificationStatus = async (payload) => {
  try {
    const response = await axios.put(`${PUT_NOTIFICATIONS_STATUS}`, payload);
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: `Error updating job status: ${error}`,
      error: error,
    };
  }
};

const checkUnreadNotifications = async (userId, checkDate) => {
  let url =
    GET_UNREAD_NOTIFICATIONS +
    `?userId=${userId}&currentCheckDate=${checkDate}`;

  try {
    const response = await axios.get(url);
    if (response.status === 200 || response.status === 201) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "An error occurred while processing the data.",
      error: error,
    };
  }
};

const saveFirebaseToken = async (fcmTokenValue) => {
  const userId = getStorageValue("userId");

  const payload = {
    userId: userId,
    fcmToken: fcmTokenValue,
    isAndroid: false,
    isWeb: true
  }
  try {
    const response = await axios.post(SAVE_FIREBASE_TOKEN, payload);
    if (response.status === 200 || response.status === 201) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "An error occurred while processing the data.",
      error: error,
    };
  }
};

const disableFirebaseToken = async (userId) => {
  const fcmTokenValue = getEncryptedStorageValue("fcmtoken");
  const payload = {
    userId: userId,
    fcmToken: fcmTokenValue,
  }
  try {
    const response = await axios.post(LOGOUT_FIREBASE_TOKEN, payload);
    if (response.status === 200 || response.status === 201) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "An error occurred while processing the data.",
      error: error,
    };
  }
};

const NotificationsListAPI = {
  fetchNotificationsList,
  updateNotificationStatus,
  checkUnreadNotifications,
  saveFirebaseToken,
  disableFirebaseToken
};

export default NotificationsListAPI;
